import React from 'react';
import { Button, Container, CircularProgress, Typography } from '@material-ui/core';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import { withStyles } from '@material-ui/core/styles';
import { useDestinationUpdate } from '../../../hooks';
import TablePreview from '../TablePreview';
import QueryUpdater from '../QueryUpdater';
import EtlCard from './EtlCard';
import theme from '../../theme';
var DestinationDetail = function (_a) {
    var destination = _a.destination, etl = _a.etl, reload = _a.reload;
    var _b = useDestinationUpdate(etl.id, reload), updating = _b.updating, handleUpdateEtl = _b.handleUpdateEtl, query = _b.query, setQuery = _b.setQuery, variables = _b.variables, setVariables = _b.setVariables, rows = _b.rows, setRows = _b.setRows;
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, { style: {
                display: 'flex',
                flexDirection: 'row-reverse',
                flexWrap: 'wrap',
            } },
            React.createElement(QueryUpdater, { datasourceId: etl.datasourceId, defaultSql: etl.sql, query: query, setQuery: setQuery, variables: variables, setVariables: setVariables, setRows: setRows }),
            React.createElement(EtlCard, { etl: etl, variables: variables })),
        updating ? (React.createElement(Container, null,
            "updating...",
            React.createElement(CircularProgress, null))) : (React.createElement(React.Fragment, null,
            React.createElement(TablePreview, { key: "currentDestination", title: 'Table: ' + destination.tableName, loading: !etl, data: destination.previews ? destination.previews : null }),
            rows ? (React.createElement(React.Fragment, null,
                React.createElement(AsToIcon, null),
                React.createElement(TablePreview, { key: "diffDestination", loading: false, data: rows, perPage: 10, child: React.createElement(Button, { disabled: !rows.length, variant: "contained", color: "primary", onClick: handleUpdateEtl }, "Confirm Update") }))) : null))));
};
var AsToIcon = withStyles({
    root: {
        textAlign: 'center',
        color: theme.palette.text.primary,
    },
    icon: {
        transform: 'rotate(90deg)',
    },
})(function (_a) {
    var classes = _a.classes;
    return (React.createElement(Container, { className: classes.root },
        React.createElement(DoubleArrowIcon, { className: classes.icon }),
        React.createElement(Typography, null, " AS TO ")));
});
export default DestinationDetail;
